import React                  from 'react';
import PropTypes              from 'prop-types';
import Block                  from '../Block';
import Header                 from './Header';
import Translations           from '../../../utils/Translations';
import ButtonRow              from './ButtonRow';
import Flux                   from '../../../flux/Flux';
import {trackClick}           from '../../../utils/GAHelper';
import CategoriesOverviewGrid from "../../Categories/CategoriesOverviewGrid";
import Constants              from "../../../flux/Constants";

class CategoriesBlock extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			total:        null,
			displayCount: 5,
		};

		this.onWindowResize = this.onWindowResize.bind(this);
	}

	componentDidMount() {
		Flux.Browser.addWindowResizeListener(this.onWindowResize);
		this.onWindowResize();
	}

	componentWillUnmount() {
		Flux.Browser.removeWindowResizeListener(this.onWindowResize);
	}

	onWindowResize() {
		const width = Flux.Browser.getWindowSize().width;
		this.setState({
			displayCount: (width < Constants.Grid2.BREAKPOINT_MIN_WIDTHS.sm) ? 4
						: ((width < Constants.Grid2.BREAKPOINT_MIN_WIDTHS.md) ? 3
						: (width < Constants.Grid2.BREAKPOINT_MIN_WIDTHS.lg) ? 4 : 5)
		});
	}

	render() {
		return (
			<Block className="categories" idName="categories-block">
				<Header
					title={this.props.title}
					hasCount={true}
					count={this.state.total ? this.state.total : 0}
					countLabel={this.state.total ? Translations.get('HomepageV2CategoriesPlural') : ''}
					headlineType={this.props.headlineType}
				/>
				<CategoriesOverviewGrid
					sort={Flux.Constants.Vxql.Collection.Order.VIEWS}
					displayCount={this.state.displayCount}
					first={this.state.displayCount}
					columns={{xs: 2, sm: 3, md: 4, lg: 5}}
					onLoaded={data => this.setState({total: Object.keys(data.data.collections_v2).length})}
					headlineType={"h3"}
                    collectionNames={Flux.Browser.isSpanishPfm() ? ['spanish', 'milf', 'latina', 'petite', 'big_tits'] : []}
				/>
				<ButtonRow
					cta={Translations.get('HomepageV2CategoriesAll')}
					link={this.props.link}
					callback={() => trackClick('categories', this.props.link)}
				/>
			</Block>
		);
	}
}

CategoriesBlock.propTypes = {
	list:                 PropTypes.object,
	total:                PropTypes.number,
	link:                 PropTypes.string,
	useAdwordsCategories: PropTypes.bool,
	lazyImageLoading:     PropTypes.bool,
	headlineType:         PropTypes.oneOf(Object.values(Flux.Constants.Headlines)),
	title:                PropTypes.string,
};

CategoriesBlock.defaultProps = {
	list:                 null,
	count:                0,
	useAdwordsCategories: false,
	lazyImageLoading:     false,
	headlineType:         Flux.Constants.Headlines.h2,
	title:                Translations.get('HomepageV2CategoriesTitle'),
};

export default CategoriesBlock;
